import React, { useState } from 'react';
import clsx from 'clsx';
import { makeStyles, TextField, Typography } from '@material-ui/core';

import Style from './Style';
import Buttons from '../Buttons';
import VehicleSearchBar from '../VehicleSearchBar';

const useStyles = makeStyles(() => Style());

export default function CustomVehicle({ setToggle }) {
  const classes = useStyles();

  const [selectedVehicle, setSelectedVehicle] = useState();

  const {
    id = '',
    vehicleMake = '',
    vehicleModel = '',
    modelYear = '',
    displacement = null,
    licensePlate = '',
    vin = '',
    mcNumber = '',
    unitNumber = '',
  } = selectedVehicle || '';

  return (
    <div className={classes.custom_vehicle__main}>
      <Typography className={classes.heading}>Search Vehicle</Typography>

      {/* Vehicle Search Bar */}
      <VehicleSearchBar setSelectedVehicle={setSelectedVehicle} />

      <div className={clsx(classes.fields__main, 'w-100')}>
        <div className='d-flex space-between'>
          <div className={clsx(classes.flex__field)}>
            <Typography className={classes.label}>Vehicle Make</Typography>
            <TextField
              disabled
              value={vehicleMake}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(classes.data__field, 'c-pointer')}
            />
          </div>
          <div className={clsx(classes.flex__field)}>
            {' '}
            <Typography className={classes.label}>Vehicle Model</Typography>
            <TextField
              disabled
              value={vehicleModel}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(classes.data__field, 'c-pointer')}
            />
          </div>
        </div>
        <div className='d-flex space-between'>
          <div className={clsx(classes.flex__field)}>
            <Typography className={classes.label}>Model Year</Typography>
            <TextField
              disabled
              value={modelYear}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(classes.data__field, 'c-pointer')}
            />
          </div>
          <div className={clsx(classes.flex__field)}>
            <Typography className={classes.label}>Engine Size</Typography>
            <TextField
              disabled
              value={displacement}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(classes.data__field, 'c-pointer')}
            />
          </div>
        </div>
        <div className='d-flex space-between'>
          <div className={clsx(classes.flex__field)}>
            <Typography className={classes.label}>License Plate</Typography>
            <TextField
              disabled
              value={licensePlate || ''}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(classes.data__field, 'c-pointer')}
            />
          </div>
          <div className={clsx(classes.flex__field)}>
            <Typography className={classes.label}>VIN</Typography>
            <TextField
              disabled
              name='vin'
              value={vin}
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(classes.data__field, 'c-pointer')}
            />
          </div>
        </div>
        <div className='d-flex space-between'>
          <div className={clsx(classes.flex__field)}>
            <Typography className={classes.label}>MC Number</Typography>
            <TextField
              disabled
              value={mcNumber || ''}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(classes.data__field, 'c-pointer')}
            />
          </div>
          <div className={clsx(classes.flex__field)}>
            <Typography className={classes.label}>Unit Number</Typography>
            <TextField
              disabled
              name='unitNumber'
              value={unitNumber}
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(classes.data__field, 'c-pointer')}
            />
          </div>
        </div>
      </div>

      {/* Actions */}
      <Buttons
        classes={classes}
        onCancel={() => {
          setToggle(false);
        }}
        selectedVehicle={selectedVehicle}
        disabled={
          !id || !vehicleMake || !vehicleModel || !modelYear || !licensePlate
        }
      />
    </div>
  );
}
